"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _excluded = ["type", "contents", "tabStyle", "className", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Tabs = function Tabs(props) {
  var type = props.type,
    contents = props.contents,
    tabStyle = props.tabStyle,
    className = props.className,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded);
  var componentClasses = (0, _classnames["default"])("tabs-component", type, tabStyle, className);
  var menus = _react["default"].Children.toArray(props.children);
  var tabs = contents.map(function (item, index) {
    var tabClasses = (0, _classnames["default"])('tab', item.className, {
      "selected": typeof props.selectedTab === "string" ? props.selectedTab === item.id : props.selectedTab === index,
      "disabled": item.disabled === true
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: tabClasses,
      onClick: function onClick(e) {
        props.onClick(e, item, index);
      },
      key: index,
      id: index,
      style: item.style
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab-content"
    }, item.content, type === "horizontal-ext-1" && index > 0 && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow-head"
    })));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClasses,
    style: style
  }, tabs);
};
Tabs.propTypes = {
  type: _propTypes["default"].oneOf(["vertical", "horizontal", "horizontal-ext-1"]),
  contents: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    content: _propTypes["default"].any,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object,
    disabled: _propTypes["default"].bool
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  tabStyle: _propTypes["default"].oneOf(["", "round"]),
  selectedTab: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Tabs.defaultProps = {
  type: "horizontal",
  contents: [],
  className: "",
  style: {},
  onClick: function onClick() {},
  tabStyle: "",
  selectedTab: null
};
var _default = exports["default"] = Tabs;